"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceName = void 0;
var getDeviceName_1 = require("./getDeviceName");
Object.defineProperty(exports, "getDeviceName", { enumerable: true, get: function () { return getDeviceName_1.getDeviceName; } });
